var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSpeakerSimpleSlash = function SvgIconSpeakerSimpleSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.689 2.102A1 1 0 0 1 15.25 3v5.897a1 1 0 1 1-2 0v-3.85l-1.526 1.189a1 1 0 0 1-1.23-1.578l3.141-2.447a1 1 0 0 1 1.054-.11M3.827 3.01a1 1 0 0 1 1.413.067L14.987 13.8l.006.005 5.247 5.772a1 1 0 0 1-1.48 1.346l-3.51-3.861V21a1 1 0 0 1-1.614.79l-6.48-5.04H3A1.75 1.75 0 0 1 1.25 15V9A1.75 1.75 0 0 1 3 7.25h3.33L3.76 4.423a1 1 0 0 1 .067-1.413M8.15 9.25H3.25v5.5H7.5a1 1 0 0 1 .614.21l5.136 3.995v-4.093zm13.226-2a1 1 0 0 1 1 1v7.5a1 1 0 1 1-2 0v-7.5a1 1 0 0 1 1-1M19 9.75a1 1 0 1 0-2 0v3.272a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconSpeakerSimpleSlash;